<template>
	<div >
		<div class="tabs-container">
			<div class="tabs">
				<a v-for="(entry, index) in customerProducts" :key="entry.name" @click="selectProduct(index)"
					:class="entry.name === selectedProduct.name && 'active'" 
					>
					<!-- {{entry.name}} {{entry.card}} {{entry}} -->
					<img :class="entry.paper === 2 && 'cadhoc'" :src="require('@/assets/images/logo-up-new-' +
					(entry.card ? entry.card : entry.paper) +
					'.png')
					" />
				</a>
			</div>
		</div>

		<div align="center" class="select-left">
			<select class="mobile" @change="selectedProductMobile">
				<option v-for="(entry, index) in customerProducts" :key="index" :value="index"
					:selected="isSelectedProduct(entry)">
					{{ getProductName(entry.paper > 0 ? entry.paper : entry.card) }}
				</option>
			</select>
		</div>

		<div class="banner-stats" v-if="dashboardInfos">
			<div class="circle1 stats-circle">
				<h1 v-html="$t('dashboardInfoTitle_' + dashboardInfos[0].name, {
					value: dashboardInfos[0].value,
				})
					" />
				<small v-html="$t('dashboardInfo_' + dashboardInfos[0].name)"></small>
				<div class="icon">
					<font-awesome-icon icon="box-open" size="3x" />
				</div>
			</div>

			<div class="circle2 stats-circle">
				<h1 v-html="$t('dashboardInfoTitle_' + dashboardInfos[1].name, {
					value: dashboardInfos[1].value,
				})
					" />
				<small v-html="$t('dashboardInfo_' + dashboardInfos[1].name)"></small>
				<div class="icon">
					<font-awesome-icon icon="coins" size="3x" />
				</div>
			</div>
			<br clear="all" />
		</div>

		<div v-if="this.selectedProduct.card > 0" class="container-alb">
			<p class="invoice-title">
				<strong>{{ $t("loadingsReport") }}</strong>
			</p>
			<br />
			<table class="invoice-title">
				<tr>
					<td width="30%">
						<div class="invoice-title">
							<select class="filtrare" style="width: 200px" @change="changeYearSelected">
								<option v-for="(entry, index) in this.years" :key="index" :value="entry">
									{{ entry }}
								</option>
							</select>
						</div>
					</td>
					<td>
						<div class="invoice-title" v-if="this.selectedProduct.card === 12">
							<select class="filtrare" style="width: 200px" @change="changeBrandSelected">
								<option v-for="(entry, index) in this.giftBrands" :key="index" :value="entry"
									:selected="giftBrandSelected === entry">
									{{ $t("productBrand_" + entry) }}
								</option>
							</select>
						</div>
					</td>
				</tr>
			</table>

			<br />
			<div class="invoice-title">
				<a class="notification-action" @click="loadingsReport">{{
					$t("downloadReport")
				}}</a>
			</div>
		</div>

		<div class="container-alb">
			<p class="invoice-title">
				<strong>{{ $t("pendingOrdersTitle") }}</strong>
			</p>
			<br />
			<orders-table-desktop v-if="pendingOrders && pendingOrders.length > 0" :companyOrders="pendingOrders"
				:dashboard="true" :company="this.customer" />
			<div class="error-wrapper border-box" v-else>
				{{ $t("pendingOrdersNoOrders") }}
			</div>
			<br />
			<table cellspacing="0" width="95%" align="center">
				<tbody>
					<tr>
						<td class="text-right">
							<a href="/customer/orders" class="notification-action">
								{{ $t("goToOrdersButton") }}
							</a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div v-if="this.selectedProduct.card > 0">
			<div class="filter">
				<select @change="selectPeriod">
					<option value="1">{{ $t("transactionStatsDDLLastMonth") }}</option>
					<option value="3">
						{{ $t("transactionStatsDDLLastMonths", { index: 3 }) }}
					</option>
					<option value="6">
						{{ $t("transactionStatsDDLLastMonths", { index: 6 }) }}
					</option>
					<option value="9">
						{{ $t("transactionStatsDDLLastMonths", { index: 9 }) }}
					</option>
					<option value="12" selected>
						{{ $t("transactionStatsDDLLastMonths", { index: 12 }) }}
					</option>
				</select>
			</div>
			<div v-if="this.totalTransactionMap > 0">
				<div class="usage-volume">
					<div class="container-alb">
						<div class="usage-volume-container">
							<p>{{ $t("usageVolumeChartTitle") }}</p>
							<br />
							<br />
							<TransactionChartCompany v-if="this.transactionChartData" :chartData="this.transactionChartData"
								:height="320" />
						</div>
					</div>
				</div>
				<br clear="all" />
				<br />
				<div class="numbers-left">
					<div class="container-alb">
						<h1>
							{{ this.cardStatisticsData.created }}
							<sup>/{{ this.cardStatisticsData.total_card }}</sup>
						</h1>
						<p>{{ $t("statsCardsInactive") }}</p>
					</div>
					<div class="container-alb">
						<h1>
							{{ Math.floor(this.averageTransactionAmount) }}
							<sup> {{ this.averageTransactionAmount | toCurrency }}</sup>
						</h1>
						<p>{{ $t("averageTransactionAmount") }}</p>
					</div>
					<div class="container-alb">
						<h1>{{ this.averageTransactionNumber }}</h1>
						<p>{{ $t("averageTransactionNumber") }}</p>
					</div>
				</div>
				<div class="usage-country">
					<div class="container-alb">
						<div class="usage-volume-container">
							<table cellpadding="0" cellspacing="0" width="100%">
								<tr>
									<td align="left">
										<p>
											<strong>{{ $t("usagePerRegion") }}</strong>
										</p>
									</td>
									<td align="right">
										<!-- <small>During the past month</small> -->
									</td>
								</tr>
							</table>

							<br />
							<br />
							<MapTemplate v-if="this.transactionMapData" :countyList="this.transactionMapData"
								:refNumber="this.totalTransactionMap" style="width: 100%; height: 300px" />
							<br />
							<br />
						</div>
					</div>
				</div>
			</div>
			<div v-else class="container-alb">
				<div class="usage-volume-container">
					<p>
						<strong>{{ $t("noTransactionsTitle") }}</strong>
					</p>
					<br />
					<p>{{ $t("noTransactionsMessage") }}</p>
				</div>
			</div>
		</div>

		<div id="modal_popup_info" class="modal-popup">
			<div class="modal-popup-content">
				<a @click="showModalPopup('modal_popup_info', false)" class="close-button">
					<img src="@/assets/images/close-button.svg" />
				</a>
				<p v-if="this.error" v-html="$t('errorActionBeneficiary_' + this.error.code)"></p>
				<!-- <p v-if="this.newOrder.successLink && this.orderStep === 4" v-html="$t('actionUploadFileSuccess')"></p> -->
			</div>
		</div>
	</div>
</template>

<script>
	import MapTemplate from "@/assets/components/MapTemplate.vue";
	import TransactionChartCompany from "@/components/company/TransactionChartCompany.vue";
	import OrdersTableDesktop from "./OrdersTableDesktop.vue";
	import utils from "@/plugins/utils.js";
	// import products from "@/assets/json/products.js";

	import httpServiceCustomer from "@/http/http-customer.js";
	import moment from "moment";
	import Cookies from "js-cookie";
	import $ from "jquery";
	import { saveAs } from "file-saver";

	export default {
		props: {
			customer: Object,
			msg: String,
		},
		components: {
			MapTemplate,
			TransactionChartCompany,
			OrdersTableDesktop,
		},
		data() {
			return {
				// customer: null,
				// customerDataLoaded: false,
				customerBeneficiaries: null,
				dashboardInfos: null,
				transactionChartData: null,
				transactionMapData: null,
				cardStatisticsData: {
					customer_id: 1,
					product: 11,
					total_card: 259,
					blocked: 24,
					activated: 187,
					created: 19,
					with_sms: 199,
				},
				customerError: null,
				totalTransactionMap: 0,
				selectedProduct: null,
				selectedPeriod: 12,
				averageTransactionAmount: 0,
				averageTransactionNumber: 0,
				pendingOrders: null,
				cardRecommend: [
					{
						id: 1,
					},
					{
						id: 2,
					},
					{
						id: 3,
					},
					{
						id: 4,
					},
				],
				currentCardOffer: null,
				cardOfferIndex: 0,
				years: null,
				yearSelected: 2020,
				giftBrands: ["rewards", "gift"],
				giftBrandSelected: "gift",
				error: null,
				customerProducts: null,
			};
		},
		methods: {
			selectProduct(index) {
				this.selectedProduct = this.customerProducts[index];
				this.getCustomerDashboardInfo();
			},
			selectedProductMobile(event) {
				this.selectedProduct = this.customerProducts[event.target.value];
				this.getCustomerDashboardInfo();
			},
			isSelectedProduct(product) {
				return product + "" === this.selectedProduct;
			},
			selectPeriod(event) {
				this.selectedPeriod = event.target.value;
				this.getCustomerDashboardInfo();
			},
			selectCardOffer(index) {
				this.currentCardOffer = this.cardRecommend[index];
			},
			previousCardOffer() {
				let numberOfCardOffers = this.cardRecommend.length;
				this.cardOfferIndex--;
				if (this.cardOfferIndex < 0) {
					this.cardOfferIndex = numberOfCardOffers - 1;
				}
				this.currentCardOffer = this.cardRecommend[this.cardOfferIndex];
			},
			nextCardOffer() {
				let numberOfCardOffers = this.cardRecommend.length;
				this.cardOfferIndex++;
				if (this.cardOfferIndex === numberOfCardOffers) {
					this.cardOfferIndex = 0;
				}
				this.currentCardOffer = this.cardRecommend[this.cardOfferIndex];
			},
			getCustomerDashboardInfo() {
				this.getDashboardGeneralInfos();
				this.getTransactionsVolumeMapData();
				this.getTransactionsVolumeChartData();
				this.getCardStatisticsData();
				this.getPendingOrders();
			},
			getDashboardGeneralInfos() {
				var formData =
					"?customer_id=" +
					this.customer.company_id +
					"&brand=" +
					this.selectedProduct.brand;

				httpServiceCustomer.customerService
					.getDashboardInfos(
						this.customer.company_id,
						formData,
						Cookies.get("token")
					)
					.then(function (response) {
						// handle success
						return response;
					})
					.catch(function () {
						// handle success
					})
					.then((response) => {
						if (response.status == 200) {
							this.dashboardInfos = response.data;
						} else if (response.status == 400 || response.status == 403) {
							this.dashboardError = {
								code: response.data,
								description: "Error fetching dashboard info data",
							};
						} else {
							this.dashboardError = { description: response.description };
						}

					});
			},
			getTransactionsVolumeMapData() {
				if (!this.selectedProduct.card) {
					return;
				}
				var transactionsData =
					"?type=" +
					"tr.summary" +
					"&customer_id=" +
					this.customer.company_id +
					"&product=" +
					this.selectedProduct.card +
					"&months=" +
					this.selectedPeriod;

				httpServiceCustomer.customerService
					.getTransactionVolume(transactionsData, Cookies.get("token"))
					.then(function (response) {
						// handle success
						return response;
					})
					.catch(function () {
						// handle success
					})
					.then((response) => {
						if (response.status == 200) {
							this.totalTransactionMap = response.headers["x-up-count1"] * 1;
							this.transactionMapData = response.data;
							if (this.transactionMapData !== null && this.transactionMapData.length === 0) {
								this.totalTransactionMap = 0;
							}
						} else if (response.status == 400 || response.status == 403) {
							this.dashboardError = {
								code: response.data,
								description: "Error fetching transactions",
							};
							this.totalTransactionMap = 0;
						} else {
							this.dashboardError = { description: response.description };
							this.totalTransactionMap = 0;
						}

					});
			},
			getProductName(productId) {
				return utils.getProductName(productId);
			},
			getTransactionsVolumeChartData() {
				if (!this.selectedProduct.card) {
					return;
				}
				var transactionsData =
					"?type=" +
					"tr.number" +
					"&customer_id=" +
					this.customer.company_id +
					"&product=" +
					this.selectedProduct.card +
					"&months=" +
					this.selectedPeriod;

				httpServiceCustomer.customerService
					.getTransactionVolume(transactionsData, Cookies.get("token"))
					.then(function (response) {
						// handle success
						return response;
					})
					.catch(function () {
						// handle success
					})
					.then((response) => {
						if (response.status == 200) {
							this.totalTransactionMap = response.headers["x-up-count1"] * 1;
							this.transactionChartData = response.data;
							if (this.transactionChartData !== null && this.transactionChartData.length === 0) {
								this.totalTransactionMap = 0;
							}
							this.fillChartData();
						} else if (response.status == 400 || response.status == 403) {
							this.dashboardError = {
								code: response.data,
								description: "Error fetching transactions",
							};
							this.totalTransactionMap = 0;
						} else {
							this.dashboardError = { description: response.description };
							this.totalTransactionMap = 0;
						}

					});
			},
			getCardStatisticsData() {
				if (!this.selectedProduct.card) {
					return;
				}
				var transactionsData =
					"?customer_id=" +
					// 62654 +
					this.customer.company_id +
					"&product=" +
					this.selectedProduct.card;

				httpServiceCustomer.customerService
					.getCardsStatistics(transactionsData, Cookies.get("token"))
					.then(function (response) {
						// handle success
						return response;
					})
					.catch(function () {
						// handle success
					})
					.then((response) => {
						if (response.status == 200) {
							this.cardStatisticsData = response.data;
						} else if (response.status == 400 || response.status == 403) {
							this.dashboardError = {
								code: response.data,
								description: "Error fetching transactions",
							};
						} else {
							this.dashboardError = { description: response.description };
						}

					});
			},
			fillChartData() {
				if (this.transactionChartData != null) {
					let chartDataTemp = [];
					let index = this.transactionChartData.length - 1;
					let totalAverage = 0;
					let totalTransactions = 0;
					moment.locale(localStorage.language);
					while (index >= 0) {
						totalAverage += this.transactionChartData[index].transactions_amount;
						totalTransactions += this.transactionChartData[index]
							.transactions_number;
						chartDataTemp.push({
							date: moment(
								new Date(this.transactionChartData[index].transactions_date),
								"YYYY-MM-DD"
							).format("MMM YYYY"),
							average: this.transactionChartData[index].transactions_amount,
							count: this.transactionChartData[index].transactions_number,
						});
						index--;
					}
					this.averageTransactionAmount = totalAverage / totalTransactions;
					this.averageTransactionNumber = Math.ceil(
						totalTransactions / (this.selectedPeriod * 30)
					);

					let dateTransactions = chartDataTemp.map((a) => a.date);
					this.transactionChartData = {
						labels: dateTransactions,
						datasets: [
							{
								label: this.$t("averageChartLabel"),
								yAxisID: "amount",
								backgroundColor: "#f79000",
								borderColor: "#f79000",
								borderWidth: 2,
								data: chartDataTemp.map((a) => a.average),
								fill: false,
								pointRadius: 0,
							},
							{
								label: this.$t("countChartLabel"),
								yAxisID: "count",
								borderWidth: 2,
								backgroundColor: "#864e00",
								borderColor: "#864e00",
								data: chartDataTemp.map((a) => a.count),
								fill: false,
								pointRadius: 0,
							},
						],
					};
				}
			},
			getPendingOrders() {
				var ordersData =
					"?brand=" +
					this.selectedProduct.brand +
					"&status=P,N,V2,PR,PV";
				"&per_page=5" + "&page=1";
				httpServiceCustomer.customerService
					.searchOrders(
						ordersData,
						this.customer.company_id,
						Cookies.get("token")
					)
					.then(function (response) {
						// handle success
						return response;
					})
					.catch(function () {
						// handle success
					})
					.then((response) => {
						if (response.status == 200) {
							this.pendingOrders = response.data.results;
						} else if (response.status == 400 || response.status == 403) {
							this.orderError = {
								code: response.data,
								description: "Error fetching pending orders",
							};
						} else {
							this.orderError = { description: response.description };
						}
						this.showModalPopup("modal_popup_loading", false);
					});
			},
			getStyle(width) {
				return "width:" + width + "%";
			},
			getYears() {
				const years = [];
				const dateStart = moment("2018");
				const dateEnd = moment().year();
				while (dateEnd - parseInt(dateStart.format("YYYY")) >= 0) {
					years.push(dateStart.format("YYYY"));
					dateStart.add(1, "year");
				}
				this.years = years.reverse();
			},
			changeYearSelected(event) {
				this.yearSelected = event.target.value;
			},
			changeBrandSelected(event) {
				this.giftBrandSelected = event.target.value;
			},
			loadingsReport() {
				this.showModalPopup("modal_popup_loading", true);
				var params =
					"?year=" + this.yearSelected + "&product=" + this.selectedProduct.card;
				params +=
					this.selectedProduct.card === 12
						? "&brand=" + this.giftBrandSelected
						: "";
				httpServiceCustomer.customerService
					.getLoadingsReport(
						this.customer.company_id,
						params,
						Cookies.get("token")
					)
					.then(function (response) {
						// handle success
						return response;
					})
					.then((response) => {
						if (response.status == 200) {
							var blob = new Blob(
								[utils.base64ToArrayBuffer(response.data.content)],
								{
									type:
										"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetapplication/vnd.ms-excel",
								}
							);
							saveAs(blob, response.data.name);
							this.showModalPopup("modal_popup_loading", false);
						} else if (response.status == 400 || response.status == 403) {
							this.error = { code: 500 };
							this.showModalPopup("modal_popup_loading", false);
							this.showModalPopup("modal_popup_info", true);
							// return null;
						} else {
							this.error = { code: 500 };
							this.showModalPopup("modal_popup_loading", false);
							this.showModalPopup("modal_popup_info", true);
						}
					})
					.catch(() => {
						this.error = { code: 500 };
						this.showModalPopup("modal_popup_loading", false);
						this.showModalPopup("modal_popup_info", true);
					});
			},
			showModalPopup(elementId, show) {
				if (show) {
					document.getElementById(elementId).style.visibility = "visible";
				} else {
					document.getElementById(elementId).style.visibility = "hidden";
				}
			},
		},
		mounted() {
			$(".top-sellers .container-alb").height(
				$(".usage-country .container-alb").height()
			);
		},
		created() {
			this.customerProducts = utils.getCustomerDisplayProducts(
				this.customer.products
			);
			this.selectProduct(0);

			this.selectCardOffer(0);
			this.getYears();
			this.yearSelected = this.years[0]; // bau
			setTimeout(() => {
				$(".top-sellers .container-alb").height(
					$(".usage-country .container-alb").height()
				);
			}, 300);

		},
	};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
